import { render, staticRenderFns } from "./expAssessment.vue?vue&type=template&id=280c04e3&scoped=true"
import script from "./expAssessment.vue?vue&type=script&lang=js"
export * from "./expAssessment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280c04e3",
  null
  
)

export default component.exports